function Footer() {
  const browsePrivacy = () => {
    window.location.href = '/privacy'
  }
  return (
    <footer className="pt-6 pb-6 ads">
      <nav className="flex flex-wrap justify-center ">
        <span
          onClick={() => browsePrivacy()}
          className="cursor-pointer tracking-wider text-sm leading-6"
        >
          Privacy Policy
        </span>
      </nav>
    </footer>
  );
}

export default Footer;